import { z } from 'zod';

/**
 * `GET /api/me` response contract - the authenticated player's own account.
 *
 * Deliberately minimal: the UUID the rest of the system keys on, the public
 * display name and the basic account state. Never tokens, hashes, session
 * internals or anything Better Auth stores for itself.
 */
export const meResponseSchema = z.object({
  account: z.object({
    /** `accounts.id` - the one player identity, shared with the ledger. */
    id: z.uuid(),
    displayName: z.string().min(1),
    /** The player's own login email (their data; never anyone else's). */
    email: z.email(),
    /** False until a real email-verification flow exists. */
    emailVerified: z.boolean(),
    /** 18+ gate. Server-controlled; required later for paid gacha/market. */
    ageVerified: z.boolean(),
  }),
});

export type MeResponse = z.infer<typeof meResponseSchema>;

export const ME_ROUTE = '/api/me' as const;

/** Base path every Better Auth endpoint is mounted under. */
export const AUTH_BASE_PATH = '/api/auth' as const;
